
import { useCallback } from "react";
import { toast } from "@/hooks/use-toast";
import { JobFormData } from "../types/jobTypes";

/**
 * Hook for handling clipboard operations
 */
export const useJobFormClipboard = (
  jobDataRef: React.MutableRefObject<JobFormData>,
  setJobData: React.Dispatch<React.SetStateAction<JobFormData>>
) => {
  const handlePasteFromClipboard = useCallback(async () => {
    try {
      const clipboardText = await navigator.clipboard.readText();
      if (clipboardText) {
        setJobData(prevData => ({
          ...prevData,
          description: clipboardText
        }));
        
        toast({
          title: "Pasted from clipboard",
          description: "Text has been pasted into the description field.",
        });
      }
    } catch (error) {
      console.error("Failed to read clipboard:", error);
      toast({
        title: "Clipboard access failed",
        description: "Please check your browser permissions for clipboard access.",
        variant: "destructive",
      });
    }
  }, [setJobData]);

  return { handlePasteFromClipboard };
};
